import React, { useState } from "react";
import avatar from "../../assets/images/avatar.png";

const EditTaskModal = ({ closeModal , setSuccessModal }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [followUp, setFollowUp] = useState("");
 

  const handleSaveOfRescheduleTask = () => {
    closeModal();
    setSuccessModal(true);
  };
  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container py-4 px-10 rounded-lg w-[30%]">
        <div className="flex flex-col ">
          <div className="flex justify-center">
            <div className="text-[20px] font-bold">Edit task</div>
          </div>

          <div className="flex items-center mt-6">
            <img src={avatar} alt="profile pic" className="w-6 rounded-full" />
            <p className="ml-2 text-[16px] font-bold">Praveen Sharma</p>
          </div>

          <div className="text-[#828282] text-[14px] mt-6">
            Currently Assigned to:
            <span className="text-[#333333]">Rahul Sharma</span>
          </div>

          <div className="mt-6 text-[12px] text-[#828282]">Current Task</div>
          <div>
            <select
              value={followUp}
              onChange={(e) => setFollowUp(e.target.value)}
              className="border border-[#2F80ED] p-2 w-full rounded-lg text-[14px]"
            >
              <option value="" disabled hidden className="text-[#667085]">
                Follow up (Call)
              </option>
              <option value="email" className="text-[12px]">
                Follow up (Email)
              </option>
              <option value="whatsaap" className="text-[12px]">
                Follow up (Whatsapp)
              </option>
            </select>
          </div>

          <div className="text-[#828282] text-[14px] mt-6">Transfer to</div>
          <div>
            <select
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              className="border border-[#2F80ED] p-2 w-full rounded-lg text-[14px]"
            >
              <option value="" disabled hidden>
                Search & select the person
              </option>
              <option value="person1" className="text-[12px]">
                Amit Gupta
              </option>
              <option value="person2" className="text-[12px]">
                Rohit Mehta
              </option>
            </select>
          </div>
          <div className="flex justify-between my-5">
            <button
              className="w-6/12 bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg"
              onClick={closeModal}
            >
              Discard
            </button>
            <button
              className="w-6/12 bg-[#2F80ED] ml-2 p-2 text-white rounded-lg"
              onClick={handleSaveOfRescheduleTask}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditTaskModal;
